import { render, staticRenderFns } from "./AttendeeList.vue?vue&type=template&id=a871374c&scoped=true"
import script from "./AttendeeList.vue?vue&type=script&lang=js"
export * from "./AttendeeList.vue?vue&type=script&lang=js"
import style0 from "./AttendeeList.vue?vue&type=style&index=0&id=a871374c&prod&scoped=true&lang=css"
import style1 from "./AttendeeList.vue?vue&type=style&index=1&id=a871374c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a871374c",
  null
  
)

export default component.exports